import React, { useState } from "react";
import { GelRowLayout, GelButton, GelScreenDetector } from "@tal-gel/components";
import { GelThemeProvider } from "@tal-gel/theming";
import { buttonStyle, linkButton } from "../Shared/Styles";
import { MapSourceSystemCode } from "../Shared/MapSourceSystemCode";
import policySourceSystem from '../Shared/policySourceSystem';
import { Link, useRouteMatch } from "react-router-dom";
import { get, has } from "lodash";
import "../../setupTalGel";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

export default function ActionButtons(props) {
  const queryString = window.location.search;
  let { url } = useRouteMatch();
  let query = useQuery();
  const [policyNumber] = useState(query.get("policyNumber"));
  const [distributorNo] = useState(query.get("distributorNo"));

  var policyStatus = get(props.policyDetails, "policy.status", "");

  var policyOriginCode = get(props.policies, '[0].sourceSystemCode', '');
  var policyOriginName = MapSourceSystemCode(policyOriginCode);
  var isCoC = props.certificateOfCurrency;
  var isJointBTLife = false;
  var sourceSystemName = policySourceSystem(props.policies);
  var isProposalOrLapsed = false;
  if (props.policyDetails.policy && props.policyDetails.policy.policyOwner && props.policyDetails.policy.policyOwner.ownershipType === "Joint" && sourceSystemName === "PPlans" && (props.policyDetails.policy.status === "In Force" || props.policyDetails.policy.status === "Renewal" || props.policyDetails.policy.status === "Overdue")) {
    isJointBTLife = true;
  }

  if (props.policyDetails.policy && (props.policyDetails.policy.status === "Lapsed" || props.policyDetails.policy.status === "In Suspense")) {
    isProposalOrLapsed = true;
  }



  var ebqurl = "";
  var isWppProduct = props.productCode === "WPP";

  const params = window.location.search;

  const enableWppEbqApp = document.getElementById("enableWppEbqApp").innerText;
  const isEbqAdviser = document.getElementById("isEbqAdviser").innerText;

  if (enableWppEbqApp && enableWppEbqApp.toLowerCase() === "true" && isEbqAdviser && isEbqAdviser.toLowerCase() === "true" && isWppProduct) {
    ebqurl = `${window.location.origin}/dashboard/ebq-policy-details${params}`;
  }

  function gotoEBQ() {
    if (ebqurl) {
      window.location.href = ebqurl;
    }
  }

  return (
    <GelThemeProvider>
      <GelScreenDetector>
        {isCoC && isJointBTLife && (
          <p><strong>Please Note:</strong> This policy has multiple owners.  Please refer to the last renewal letter or policy schedule for all policy ownership details, or alternatively to request a Certificate of Currency please contact us at PPInsurance@tal.com.au .</p>
        )}
        <GelRowLayout gutter="medium">
          <Link to={`${url}/payment-details${queryString}`} style={linkButton}>
            <GelButton style={buttonStyle} secondary medium stretch>
              Payment Details
            </GelButton>
          </Link>
        </GelRowLayout>

        <GelRowLayout gutter="medium">
          <Link
            to={`${url}/policy-exclusions-and-loadings${queryString}`}
            style={linkButton}
          >
            <GelButton disabled={sourceSystemName === "PPlans" ? true : false} style={buttonStyle} secondary medium stretch>
              Policy Exclusion and Loadings
            </GelButton>
          </Link>
        </GelRowLayout>
        {policyOriginCode !== undefined && policyOriginCode.length > 0 && policyOriginCode.toUpperCase() === "LFH" &&

          <GelRowLayout gutter="medium">
            <Link
              to={`${url}/request-policy-documents${queryString}`}
              style={linkButton}
            >
              <GelButton style={buttonStyle} secondary medium stretch>
                Request Policy Documents
              </GelButton>
            </Link>
          </GelRowLayout>
        }

        {policyOriginCode !== undefined && policyOriginCode.length > 0 && policyOriginCode.toUpperCase() === "CLO" &&
          <GelRowLayout gutter="medium">
            <Link
              to={`${url}/view-correspondence?policyNumber=${policyNumber}&distributorNo=${distributorNo}&sourceSystem=${policyOriginCode}`}
              style={linkButton}>
              <GelButton style={buttonStyle} secondary medium stretch >View Correspondence</GelButton>
            </Link>
          </GelRowLayout>
        }

        <GelRowLayout gutter="medium">
          <Link to={`search-forms-and-documents?administrationFormsId=ct_0D5C5860FCC441A6848139391F99317B`} style={linkButton} target="_blank">
            <GelButton style={buttonStyle} secondary medium stretch>Search Administration Forms</GelButton>
          </Link>
        </GelRowLayout>

        <GelRowLayout gutter="medium">
          {ebqurl ? <GelButton onClick={gotoEBQ} style={buttonStyle} secondary medium stretch>
            Request Existing Business Quote
          </GelButton> : <Link
            to={`${url}/request-existing-business-quote${queryString}`}
            style={linkButton}
          >
            <GelButton style={buttonStyle} secondary medium stretch>
              Request Existing Business Quote
            </GelButton>
          </Link>
          }
        </GelRowLayout>
        {isCoC && !isJointBTLife && policyStatus !== undefined && !isProposalOrLapsed && (
          <GelRowLayout gutter="medium">
            <Link
              target="_blank"
              to={`${url}/request-certificate-of-currency${queryString}&policyStatus=${policyStatus}&policyOrigin=${policyOriginName}`}
              style={linkButton}
            >
              <GelButton style={buttonStyle} secondary medium stretch>
                View Certificate of Currency
              </GelButton>
            </Link>

            {policyOriginName === "TAL" && (<Link
              to={`${url}/request-policy-summary?policyNumber=${policyNumber}&policyStatus=${policyStatus}&distributorNo=${distributorNo}`}
              style={linkButton}
            >
              <GelButton style={buttonStyle} secondary medium stretch>
                View Policy Summary
              </GelButton>
            </Link>)}

          </GelRowLayout>
        )}

        {props.beneficiaries.length > 0 && (
          <GelRowLayout gutter="medium">
            <Link to={`${url}/beneficiaries${queryString}`} style={linkButton}>
              <GelButton
                style={buttonStyle}
                secondary
                medium
                stretch
                onClick={props.toggleDisplayBeneficiaries}
              >
                Beneficiaries
              </GelButton>
            </Link>
          </GelRowLayout>
        )}

        {sourceSystemName === "PPlans" && (
          <p><strong>Note:</strong> For details of loadings and policy exclusions please refer to the most recent renewal statement or policy schedule applicable to the policy </p>
        )}
      </GelScreenDetector>
    </GelThemeProvider>
  );
}
